var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pallet-rack-section--component",style:({ fontSize: _vm.size + 'px', position: 'relative' })},[_c('div',{style:({
      height: _vm.mmToEm(_vm.selectedHeight),
      marginTop: '2rem'
    })},[_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(
          (_vm.includeImpactProtectors ? 180 : 0) +
            _vm.index * (_vm.sector.beam.length + _vm.selectedUprights.width)
        )
      })},[_c('div',{style:({
          position: 'relative'
        })},[_c('pallet-rack-gable',{attrs:{"is-leftmost":_vm.isLeftmost,"is-rightmost":_vm.isRightmost,"sector":_vm.sector}}),_vm._l((_vm.levels),function(level,i){return _c('div',{key:i,style:({
            position: 'absolute',
            left: _vm.mmToEm(_vm.selectedUprights.width - 30),
            top: _vm.mmToEm(_vm.selectedHeight - level),
            width: _vm.mmToEm(_vm.sector.beam.length + 60),
            zIndex: 1001
          })},[_c('pallet-rack-level',{attrs:{"index":i,"sector":_vm.sector}})],1)}),_c('div',{style:({
            position: 'relative',
            top: _vm.selectedHeight / 1000 + 1 + 'em'
          })},[_c('div',{style:({
              left: 0,
              top: _vm.mmToEm(150),
              position: 'absolute'
            })},[_c('pallet-rack-gable-top',{attrs:{"is-leftmost":_vm.isLeftmost,"is-rightmost":_vm.isRightmost,"sector":_vm.sector,"is-upper":true}}),_c('div',{style:({
                position: 'absolute',
                background:
                  'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                left: _vm.mmToEm(_vm.selectedUprights.width),
                width: _vm.mmToEm(_vm.sector.beam.length),
                height: _vm.mmToEm(55),
                top: _vm.mmToEm(_vm.doubleRack ? 25 : 0)
              })}),_c('div',{style:({
                position: 'absolute',
                background:
                  'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                left: _vm.mmToEm(_vm.selectedUprights.width),
                top: _vm.mmToEm(1100 - 55 + (_vm.doubleRack ? 25 : 0)),
                width: _vm.mmToEm(_vm.sector.beam.length),
                height: _vm.mmToEm(55)
              })}),_c('div',{style:({
                position: 'relative',
                top: _vm.mmToEm(-50 + (_vm.doubleRack ? 25 : 0)),
                left: _vm.mmToEm(_vm.selectedUprights.width),
                width: _vm.mmToEm(_vm.sector.beam.length),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around'
              })},[_vm._l((_vm.sector.beam.pallets),function(pallet){return [_c('div',{key:`top-${_vm.index}:${pallet}`,staticClass:"pallet-level-pallet",style:({
                    borderSize: 'border-box',
                    width: _vm.mmToEm(800),
                    height: _vm.mmToEm(1200),
                    backgroundColor: '#fce2c9'
                  })})]})],2)],1),(_vm.doubleRack)?_c('div',{style:({
              left: 0,
              top: _vm.mmToEm(1100 + 250 + 150),
              position: 'absolute'
            })},[_c('pallet-rack-gable-top',{attrs:{"is-leftmost":_vm.isLeftmost,"is-rightmost":_vm.isRightmost,"sector":_vm.sector,"is-upper":false}}),_c('div',{style:({
                position: 'absolute',
                background:
                  'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                left: _vm.mmToEm(_vm.selectedUprights.width),
                width: _vm.mmToEm(_vm.sector.beam.length),
                height: _vm.mmToEm(55),
                top: _vm.mmToEm(-25)
              })}),_c('div',{style:({
                position: 'absolute',
                background:
                  'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                left: _vm.mmToEm(_vm.selectedUprights.width),
                top: _vm.mmToEm(1100 - 80),
                width: _vm.mmToEm(_vm.sector.beam.length),
                height: _vm.mmToEm(55)
              })}),_c('div',{style:({
                position: 'relative',
                top: _vm.mmToEm(-75),
                left: _vm.mmToEm(_vm.selectedUprights.width),
                width: _vm.mmToEm(_vm.sector.beam.length),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around'
              })},[_vm._l((_vm.sector.beam.pallets),function(pallet){return [_c('div',{key:`top2-${_vm.index}:${pallet}`,staticClass:"pallet-level-pallet",style:({
                    borderSize: 'border-box',
                    width: _vm.mmToEm(800),
                    height: _vm.mmToEm(1200),
                    backgroundColor: '#fce2c9'
                  })})]})],2)],1):_vm._e()])],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }